import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { t, Trans } from '@lingui/macro'
import IconGroup from '../common/icons/IconGroup'
import {
  FacebookIcon, InstagramIcon, LinkedInIcon, YoutubeIcon, TwitterIcon
} from '../common/icons/SvgIcons'
import LocalisedImage from '../common/LocalisedImage'

import accreditationImages from '../../../assets/accreditations'
import yotiLogo from '../../../assets/yoti-logo.svg'

import './Footer.scss'

const CURRENT_YEAR = new Date().getFullYear()
const FOOTER_HEADING = t`Be the first to know`
const FOOTER_INFORMATION = t`
  We've always got useful information to share: 
  new country passports supported, 
  new places where Yoti is accepted and more.
`
const FOOTER_COPYRIGHT = `© Yoti Ltd. ${CURRENT_YEAR}`

const socialIcons = [
  { anchor: { href: 'https://www.facebook.com/getYoti' }, component: <FacebookIcon /> },
  { anchor: { href: 'https://twitter.com/getyoti' }, component: <TwitterIcon /> },
  { anchor: { href: 'https://www.youtube.com/channel/UCFM8ECMDGFhamlczBagtGuw' }, component: <YoutubeIcon /> },
  { anchor: { href: 'https://www.linkedin.com/company/yoti-digital-identity' }, component: <LinkedInIcon /> },
  { anchor: { href: 'https://www.instagram.com/getyoti' }, component: <InstagramIcon /> }
]
const accreditations = Object.values(accreditationImages).map(accreditation => (
  { component: <LocalisedImage src={accreditation} alt={t`Accreditation`} /> }
))

const YotiLogo = <LocalisedImage alt={t`Yoti Logo`} src={yotiLogo} />

const Footer = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <div className="footer">
      <div className="footer__content">

        { !isMobile && (
          <div className="footer__content__yoti-logo">
            {YotiLogo}
          </div>
        )}

        <div className="footer__content__text">
          <h5><Trans id={FOOTER_HEADING} /></h5>
          <p><Trans id={FOOTER_INFORMATION} /></p>
          <IconGroup
            className="footer__content__text__social-icons"
            childClassName="footer__content__text__social-icons__icon"
            icons={socialIcons}
          />
        </div>

        <IconGroup
          className="footer__content__accreditations"
          icons={accreditations}
        />
      </div>

      <div className="footer__copyright">
        { isMobile && YotiLogo }
        <p>{ FOOTER_COPYRIGHT }</p>
      </div>
    </div>
  )
}

export default Footer
